var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionsBookmark = function SvgCollectionsBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "collections_bookmark_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.123.739h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#collections_bookmark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.123 16.739h12v-12h-2v6.125q0 .3-.25.45t-.5-.025l-1.225-.725q-.25-.15-.538-.15a.9.9 0 0 0-.512.15l-1.225.725q-.274.174-.513.025a.5.5 0 0 1-.237-.45V4.739h-5zm0 2q-.825 0-1.413-.588a1.93 1.93 0 0 1-.587-1.412v-12q0-.825.587-1.413a1.93 1.93 0 0 1 1.413-.587h12q.825 0 1.412.587.588.588.588 1.413v12q0 .825-.588 1.412a1.93 1.93 0 0 1-1.412.588zm-4 4q-.825 0-1.413-.588a1.93 1.93 0 0 1-.587-1.412v-13q0-.425.287-.713a.97.97 0 0 1 .713-.287q.424 0 .712.287.288.288.288.713v13h13q.424 0 .712.287.288.288.288.713 0 .424-.288.712a.97.97 0 0 1-.712.288z"
  }))));
};
export default SvgCollectionsBookmark;